import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react"
import MonthYearElement from "../MonthYearElement"

const DateFromToMonthYearInput = forwardRef(({
    title,
    data,
    readOnly,
    fromFinalValue,
    toFinalValue,
    maxFutureYearsFromNow = 10,
}, ref) => {

    const fromRef = useRef()
    const toRef = useRef()

    const [error, setError] = useState(false)

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const fromData = fromRef.current.validateAndGetData()
            const toData = toRef.current.validateAndGetData()

            let isValid = fromData.isValid && toData.isValid

            if (
                isValid &&
                fromData.value &&
                toData.value
            ) {
                const from = fromData.value
                const to = toData.value

                const fromTime = Number(from.year) * 12 + Number(from.month)
                const toTime = Number(to.year) * 12 + Number(to.month)

                isValid = toTime >= fromTime
            }

            setError(!isValid)

            return {
                isValid,
                value: {
                    from: fromData.value,
                    to: toData.value,
                },
            }
        },
    }))

    return (
        <div className="py-4">
            {
                title && (
                    <label className="block text-base font-medium text-gray-700 mb-4">{title}</label>
                )
            }
            <MonthYearElement
                title={"From"}
                ref={fromRef}
                data={
                    fromFinalValue === "now" ?
                        {
                            month: String(new Date().getMonth() + 1).padStart(2, '0'),
                            year: String(new Date().getFullYear()),
                        } :
                        data?.from
                }
                readOnly={readOnly || fromFinalValue === "now"}
                maxFutureYearsFromNow={maxFutureYearsFromNow}
            />
            <MonthYearElement
                title={"To"}
                ref={toRef}
                data={
                    toFinalValue === "now" ?
                        {
                            month: String(new Date().getMonth() + 1).padStart(2, '0'),
                            year: String(new Date().getFullYear()),
                        } :
                        data?.to
                }
                readOnly={readOnly || toFinalValue === "now"}
                maxFutureYearsFromNow={maxFutureYearsFromNow}
            />
            {error && (
                <p className="mt-1 text-sm text-red-600">Invalid dates</p>
            )}
        </div>
    )
})

export default DateFromToMonthYearInput
